import { useNavigate, useSearchParams } from "react-router-dom";
import SuccessPayment from "./successPayment";
import FailedPayment from "./failedPayment";
const Payment = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
    const status = searchParams.get("status");
    const message = searchParams.get("message");

  return (
    <div >
      {
         status=="ACCEPT"&&
         <SuccessPayment/>
      }
     {
         status!="ACCEPT"&&
         <FailedPayment status={status} message={message}/>
      }
    </div>
  );
};

export default Payment;
